export const handleNextImage = (setCurrentImage,images) => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  export const handlePreviousImage = (setCurrentImage,images) => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  export const timeout = {
    timeout: 1000,  // Уведомление исчезает через 2 секунды
  }